import axios from 'axios';

// Base URL for API - use main domain for Namecheap hosting
const API_BASE_URL = process.env.NODE_ENV === 'production' 
  ? 'https://mohanhao.info/api'  // Production: use main domain with /api path
  : '/api';  // Development: use proxy

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
        window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const authApi = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (userData) => api.post('/auth/register', userData),
  logout: () => api.post('/auth/logout'),
  changePassword: (passwords) => api.post('/auth/change-password', passwords),
};

export const pageApi = {
  getAll: () => api.get('/pages'),
  getBySlug: (slug) => api.get(`/pages/${slug}`),
  create: (pageData) => api.post('/pages', pageData),
  update: (id, pageData) => api.put(`/pages/${id}`, pageData),
  delete: (id) => api.delete(`/pages/${id}`),
};

export const sectionApi = {
  getByPage: (pageId) => api.get(`/sections/page/${pageId}`),
  create: (sectionData) => api.post('/sections', sectionData),
  update: (id, sectionData) => api.put(`/sections/${id}`, sectionData),
  delete: (id) => api.delete(`/sections/${id}`),
};

export const cardApi = {
  getBySection: (sectionId) => api.get(`/cards/section/${sectionId}`),
  create: (cardData) => api.post('/cards', cardData),
  update: (id, cardData) => api.put(`/cards/${id}`, cardData),
  delete: (id) => api.delete(`/cards/${id}`),
};

export const uploadApi = {
  uploadFile: (formData) => api.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
  }),
};

export const commentApi = {
  getByPage: (pageId) => api.get(`/comments/page/${pageId}`),
  getByPageAdmin: (pageId) => api.get(`/comments/admin/page/${pageId}`),
  create: (commentData) => api.post('/comments', commentData),
  update: (id, commentData) => api.put(`/comments/${id}`, commentData),
  delete: (id) => api.delete(`/comments/${id}`),
  approve: (id, isApproved) => api.put(`/comments/${id}/approve`, { isApproved }),
};

export default api; 